import { Link } from '@reach/router';
import React, { useContext, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Icon } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import { logout } from '../../../lib/auth';
import NewAccountModal from '../../../components/NewAccountModal';

const NotebookNavS = () => {
  const { notebook } = useContext(NotebookContext);
  const [showMenu, setShowMenu] = useState(false);
  const [showNewAccountModal, setShowNewAccountModal] = useState(false);

  return (
    <>
      {/* Menu Bar */}
      <div className="bg-white flex-none flex items-center pa3 z-999">
        <h1 className="flex-auto f6 normal db ma0 pr2 truncate" data-testid="notebook-name">
          <Link to="/notebook">{notebook.name}</Link>
        </h1>

        <button
          type="button"
          className="flex-none flex items-center"
          onClick={() => setShowMenu(true)}
          data-testid="nav-button"
        >
          <Icon color="navy" name="menu" size={18} viewBox={16} />
        </button>
      </div>

      {/* New Entry Button */}
      <div className="fixed bottom-0 right-0 pa3 z-9999">
        <Link
          to="/notebook/note/new"
          data-testid="create-note"
          className="hover-bg-navy bg-blue br-100 flex items-center justify-center"
          style={{ width: 60, height: 60 }}
        >
          <Icon name="pencil" size={24} viewBox={20} color="white" />
        </Link>
      </div>

      <CSSTransition in={showMenu} classNames="mobile-menu" timeout={400} unmountOnExit>
        <div className="bg-white fixed absolute--fill flex flex-column justify-between pa4 z-max mobile-menu">
          <button onClick={() => setShowMenu(false)} className="absolute top-0 right-0">
            <Icon name="close" size={24} color="navy" className="ma3" />
          </button>

          <div className="f2 display fw8" style={{ paddingTop: '10vh' }}>
            <Link
              to="/notebook"
              className="db mv2"
              onClick={() => setShowMenu(false)}
              data-testid="notebook-dashboard"
            >
              Dashboard
            </Link>
            <Link
              to="/notebook/feed"
              className="db mv2"
              onClick={() => setShowMenu(false)}
              data-testid="notebook-feed"
            >
              Feed
            </Link>
            <Link
              to="/notebook/settings"
              className="db mv2"
              onClick={() => setShowMenu(false)}
              data-testid="notebook-settings"
            >
              Settings
            </Link>
          </div>
          <ul className="f7 fw5 navy list pl0">
            <li className="flex justify-between items-center pv2">
              <Link to="/">Switch Spaces</Link>
            </li>

            <li className="pv2">
              <Link to="/notebook/account" onClick={() => setShowMenu(false)}>
                Account
              </Link>
            </li>

            <li className="pv2">
              <button onClick={logout} className="dib f7 fw5">
                Log Out
              </button>
            </li>
          </ul>
        </div>
      </CSSTransition>

      {showNewAccountModal && (
        <NewAccountModal setShowModal={() => setShowNewAccountModal(false)} />
      )}
    </>
  );
};

export default NotebookNavS;
